import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ApiService, OverviewMetrics} from "../../../services/api.service";
import {QuickCardComponent} from "../../../core/quick-card/quick-card.component";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'chatbots-quick-card',
  standalone: true,
  imports: [
    QuickCardComponent,
    MatTooltipModule,
  ],
  templateUrl: './chatbots-quick-card.component.html',
})
export class ChatbotsQuickCardComponent implements OnInit {
  loader?: Observable<OverviewMetrics>

  constructor(readonly api:ApiService) {}

  ngOnInit(): void {
    this.loader = this.api.getChatbotsOverview()
  }
}
